import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/performance';
import 'firebase/analytics';
import 'firebase/functions';

import firebaseConfig from '@/db/config';

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

db.enablePersistence()
.catch((err) => {
    if (err.code == 'failed-precondition') {
        // Multiple tabs open, persistence can only be enabled
        // in one tab at a a time.
        // ...
    } else if (err.code == 'unimplemented') {
        // The current browser does not support all of the
        // features required to enable persistence
        // ...
    }
});

const { Timestamp } = firebase.firestore;
const auth = firebase.auth();
const currentUser = auth.currentUser;
const Transaction = firebase.firestore.Transaction;
const perf = firebase.performance();
const analytics = firebase.analytics();
const functions = firebase.functions();

// firebase collections
const decksCollection           = db.collection('decks');
const usersCollection           = db.collection('users');
const profilesCollection        = db.collection('userProfiles');
const subscriptionCollection    = db.collection('subscriptions');
const dueCardNotifications      = db.collection('dueCardNotifications');
const workerTasks               = db.collection('tasks');
const usageCollection           = db.collection('usagestats');
const licensedUserUsage         = db.collection('licensedUserUsage');
const feedbackCollection        = db.collection('feedback');
const dueDateStatsCollection    = db.collection('dueCardStats');

export {
    db,
    Transaction,
    Timestamp,
    auth,
    perf,
    analytics,
    functions,
    currentUser,
    decksCollection,
    usersCollection,
    profilesCollection,
    subscriptionCollection,
    dueCardNotifications,
    workerTasks,
    usageCollection,
    licensedUserUsage,
    feedbackCollection,
    dueDateStatsCollection
};





